import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import Smmservice from "../../Page-section/social-media-marketing/Smmservice";
import Faq from "../../Page-section/social-media-marketing/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaAward,
  FaCode,
  FaCogs,
  FaPaperPlane,
} from "react-icons/fa";

const Smmprocess = () => {
  const points = [
    "   Builds brand awareness ",
    "  Generates high-quality leads ",
    "   Improves customer engagement ",
    " Increases website traffic ",
    "  Boosts sales and revenue ",
  ];
  const point = [
    "Increased Brand Awareness",
    " Higher Conversion Rates",
    " Better ROI",
    "Strong Customer Engagement",
  ];
  const pointxx = [
    "Stay in advance of competition",
    "Reach your target market faster",
    " Improve customer believe",
    "Increase sales",
  ];

  const steps = [
    {
      id: 1,
      title: "Business Analysis & Goal Setting",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We examine your business, target audience, and competition to define clear advertising goals that align along with your growth.",
    },
    {
      id: 2,
      title: "Strategy Planning",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "We create a data-pushed social media method centered on audience concentrated on, content material making plans.",
    },
    {
      id: 3,
      title: "Content Creation",
      color: "green",
      icon: <FaCode />,
      desc: "Our crew designs attractive, innovative, and amazing content material along with posts, images.",
    },
    {
      id: 4,
      title: "Campaign Execution",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We launch and manipulate focused campaigns throughout social systems, ensuring well timed shipping, audience reach.",
    },
    {
      id: 5,
      title: "Performance Monitoring",
      color: "green",
      icon: <FaAward />,
      desc: "We music key metrics like engagement, attain, and conversions using analytics equipment to measure marketing campaign achievement.",
    },
    {
      id: 6,
      title: "Continuous Optimization",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "We constantly refine techniques, take a look at new thoughts, and optimize campaigns based totally on actual-time records to improve effects.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
            <li className="active">
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>

            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Social Media Marketing is Important for Your Business</h2>

            <p>
              Social media platforms like Facebook, Instagram, LinkedIn, and
              Twitter have grow to be powerful gear for brand boom. With the
              help of professional{" "}
              <b>social media marketing services in india</b> , organizations
              can attain millions of ability clients and flip them into loyal
              clients. Here’s why social media marketing topics:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              A depended on <b>social media marketing agency in noida</b> permit
              you to leverage those advantages effectively and develop your
              commercial enterprise faster.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Our Expertise in Social Media Marketing</h3>
            <p>
              As a leading provider of social media advertising and marketing
              offerings, we assist companies create impactful techniques that
              deliver measurable outcomes. Our group of experts is familiar with
              the modern-day traits, algorithms, and target market conduct to
              craft campaigns that carry out. Being a expert{" "}
              <b>social media marketing agency</b>, we awareness on:
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Creating attractive content</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Running focused ad campaigns</h4>
                </div>
              </div>

              <div className="box">
                <div>
                  <h4>Managing social media debts</h4>
                </div>
              </div>
            </div>
            <br />
            <p>
              Our intention is to assist your brand stand out in a crowded
              digital area the use of the high-quality{" "}
              <b>social media marketing services in india.</b>
            </p>
          </div>
        </section>

        <Smmservice />

        <section className="work-process-section">
          <h3 className="work-title">Our SMM Process</h3>
          <p className="work-subtitle">
            We follow a structured approach to deliver the best social media
            marketing services:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Benefits of Our Social Media Marketing Services</h2>

            <p>
              Using expert social media marketing services, your commercial
              enterprise can reap:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Why Your Business Needs a Social Media Marketing Agency</h2>

            <p>
              Managing social media correctly calls for time, knowledge, and
              consistency. Partnering with a expert social media marketing
              agency in noida allows you to cognizance on your middle business
              at the same time as professionals deal with your on-line presence.
              With the proper social media advertising and marketing services in
              india, you may:
            </p>

            <ul>
              {pointxx.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Us?</h3>
                <p>
                  There are many organizations supplying{" "}
                  <b>social media marketing services</b>, but we stand out due
                  to:
                </p>
              </div>
            </div>
            <div className="cards">
              <div className="card">
                <h3>Proven track record </h3>
              </div>
              <div className="card">
                <h3> Experienced team </h3>
              </div>
              <div className="card">
                <h3> Customized strategies </h3>
              </div>
              <div className="card">
                <h3> Transparent reporting </h3>
              </div>
              <div className="card">
                <h3> Dedicated support </h3>
              </div>
            </div>
            <br />
            <p>
              As a trusted social media marketing enterprise, we are dedicated
              to delivering effects that depend.
            </p>
          </div>
        </section>

        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started Today</h3>
          </div>
          <div className="operations-right">
              <p>
                If you want to develop your commercial enterprise and build a
                strong online presence, it’s time to put money into expert  <b>social media marketing services</b>. Our crew is here to help you
                create powerful strategies that pressure actual consequences.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Smmprocess;
